export class KeyboardEvents {
    public static ArrowDownKey:number= 40;
    public static ArrowUpKey:number= 38;
    public static EnterKey:number= 13;
    
}